
<button [appLoader]="loading" class="btn btn-primary" (click)="download()" target="_blank"> Download </button>
